import axios from "axios";
import { get, set } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_CASESTUDY,
  REQUEST_CREATE_MASTER_CASESTUDY,
  SET_MASTER_CASESTUDY,
  SUCCESS_CREATE_MASTER_CASESTUDY,
  ERROR_GET_MASTER_CASESTUDY,
  ERROR_CREATE_MASTER_CASESTUDY,
  SUCCESS_DELETE_MASTER_CASESTUDY,
  SUCCESS_UPDATE_MASTER_CASESTUDY,
  REQUEST_DELETE_MASTER_CASESTUDY,
  REQUEST_UPDATE_MASTER_CASESTUDY,
  ERROR_DELETE_MASTER_CASESTUDY,
  ERROR_UPDATE_MASTER_CASESTUDY,
  SET_META_DATA_FOR_PAGINATION,
} from "./casestudyActionTypes";


function* requestMasterCasestudy(action: Record<string, any>): any {
  try {
    const type = get(action, "payload.type", "");
    const isFav = get(action, "payload.isFav", false);
    const serviceId = get(action, "payload.serviceId", "");
    const page = get(action, "payload.page", "");
    const pageSize = get(action, "payload.pageSize", "");
    const searchText = get(action, "payload.searchText", "");
    console.log("saga searchText", searchText);

    const result = yield call(
      getCasestudyMaster,
      type,
      isFav,
      serviceId,
      page,
      pageSize,
      searchText
    );
    console.log("result", result);

    yield put({
      type: SET_MASTER_CASESTUDY,
      payload: result.data,
      // payload: { type },
    });
    if (action.onSuccess) {
      yield call(action.onSuccess, result.data);
    }
    // console.log("dispatched", type);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_CASESTUDY, payload: message });
  }
}

function* requestUpdateMasterTagCasestudy(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterCasestudy,
      action.data.payload,
      action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_CASESTUDY,
      payload: result.data,
    });
    if (action.onSuccess) action.onSuccess(result);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_CASESTUDY, payload: message });
  }
}

// function* requestDeleteMasterTagCasestudy(action: Record<string, any>): any {
//   try {
//     yield call(deleteMasterCasestudy, get(action, "payload._id", ""));
//     yield put({
//       type: SUCCESS_DELETE_MASTER_CASESTUDY,
//       payload: get(action, "payload._id", ""),
//     });
//   } catch (error: any) {
//     let message =
//       "Something went wrong, please try again after some time or Refresh the Page.";
//     if (get(error, "response.status") === 500) {
//       message = "Something happened wrong try again after sometime.";
//     } else if (get(error, "response.status") === 422) {
//       message = "please provide valid contain";
//     } else if (get(error, "response.status") === 415) {
//       message = error.response.data.message;
//     }
//     yield put({ type: ERROR_DELETE_MASTER_CASESTUDY, payload: message });
//   }
// }

function* requestDeleteMasterTagCasestudy(action: Record<string, any>): any {
  try {
    yield call(deleteMasterCasestudy, get(action, "payload._id", ""));
    yield put({
      type: SUCCESS_DELETE_MASTER_CASESTUDY,
      payload: get(action, "payload._id", ""),
    });

    // Execute the onSuccess callback if it exists
    if (typeof action.onSuccess === "function") {
      yield call(action.onSuccess);
    }
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_CASESTUDY, payload: message });

    // Execute the onError callback if it exists
    if (typeof action.onError === "function") {
      yield call(action.onError, error);
    }
  }
}

function* requestCreateMasterCasestudy(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterCasestudy, action.payload);

    yield put({
      type: SUCCESS_CREATE_MASTER_CASESTUDY,
      payload: result.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_CASESTUDY, payload: message });
  }
}

// export function getCasestudyMaster(
//   type: string,
//   isFav: boolean = false,
//   serviceId: string
// ) {
//   console.log("serviceId", serviceId);

//   if (!type) return;
//   // if (!serviceId) return;
//   let url = `${process.env.REACT_APP_BASE_URL}/category/${type}`;

//   if (isFav) {
//     url += `?isFav=true`;
//   }
//   if (serviceId) {
//     url += `?serviceId=${serviceId}`;
//   }

//   return axios({
//     method: "GET",
//     url: url,
//     // url: `${process.env.REACT_APP_BASE_URL}/category/${type}?isFav=${isFav}`,
//     //withCredentials: true,
//   });
// }

export function getCasestudyMaster(
  type: string,
  isFav: boolean = false,
  serviceId: string = "",
  page: number = 1,
  pageSize: number = 10,
  searchText: string 
) {
  console.log("serviceId", serviceId);

  if (!type) return;

  // Start with the base URL
  let url = `${process.env.REACT_APP_BASE_URL}/category/${type}`;

  // Initialize queryParams array to store our parameters
  let queryParams = [];

  // Add parameters to the array if they exist
  if (isFav) {
    queryParams.push(`isFav=true`);
  }

  if (serviceId) {
    queryParams.push(`serviceId=${serviceId}`);
  }

  // Join all parameters with & and prefix with ? if any parameters exist
  if (queryParams.length > 0) {
    url += `?${queryParams.join("&")}`;
  }

  return axios({
    method: "GET",
    url: url,
    //withCredentials: true,
    ...(type.toLocaleLowerCase() === "all"
      ? {
          params: {
            page: page || 1,
            limit: pageSize || 10,
            searchText: searchText || "",
          },
        }
      : { params: { searchText } }),
  });
}
// export function getCasestudyMaster(type: string) {
//   const endpoint =
//     type && type !== "All"
//       ? `${process.env.REACT_APP_BASE_URL}/category/${type}`
//       : `${process.env.REACT_APP_BASE_URL}/category/All`;

//   return axios({
//     method: "GET",
//     url: endpoint,
//     //withCredentials: true,
//   });
// }

export function createMasterCasestudy(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/caseStudy/create`,
    data: payload,
    //withCredentials: true,
  });
}

export function deleteMasterCasestudy(_id: string) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/admin/caseStudy/delete/${_id}`,
    //withCredentials: true,
  });
}
export function updateMasterCasestudy(
  payload: Record<string, any>,
  _id: string
) {
  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/admin/caseStudy/update/${_id}`,
    data: payload,
    //withCredentials: true,
  });
}

const casestudyMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_CASESTUDY, requestMasterCasestudy),
    takeLatest(REQUEST_CREATE_MASTER_CASESTUDY, requestCreateMasterCasestudy),
    takeLatest(
      REQUEST_UPDATE_MASTER_CASESTUDY,
      requestUpdateMasterTagCasestudy
    ),
    takeLatest(
      REQUEST_DELETE_MASTER_CASESTUDY,
      requestDeleteMasterTagCasestudy
    ),
  ]);
};

export default casestudyMasterSaga;
